export type ImportStudyConfig = {
  /** Maximum allowed size per selected file, in bytes. */
  maxUploadSizeBytes: number;
};

export const DEFAULT_IMPORT_STUDY_CONFIG: ImportStudyConfig = {
  maxUploadSizeBytes: 500 * 1024 * 1024,
};

export function getImportStudyConfig(
  appConfig?: { importStudy?: Partial<ImportStudyConfig> }
): ImportStudyConfig {
  return {
    maxUploadSizeBytes:
      appConfig?.importStudy?.maxUploadSizeBytes ?? DEFAULT_IMPORT_STUDY_CONFIG.maxUploadSizeBytes,
  };
}
